import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Breadcrumb, SimpleCard } from "app/components";
import Loading from "app/components/MatxLoading";
import { getLeaveById } from "app/redux/actions/leave";
import { LIVE_URL, PATH } from "config";
import dayjs from "dayjs";

const ViewRequest = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { leaveDetails, loading } = useSelector((state) => state.leave);
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    dispatch(getLeaveById(id))
      .catch(err => {
        toast.error("Failed to fetch leave details.");
        navigate(PATH.ALLREQUESTS);
      });
  }, [dispatch, id, navigate]);

  useEffect(() => {
    if (leaveDetails) {
          console.log("Received leaveDetails from Redux:", leaveDetails);
      setInitialValues({
        employeeName: leaveDetails.employee?.name || "N/A",
        leaveType: leaveDetails.leaveType,
        startDate: dayjs(leaveDetails.startDate).format("MMMM D, YYYY"),
        endDate: dayjs(leaveDetails.endDate).format("MMMM D, YYYY"),
        reason: leaveDetails.reason,
        status: leaveDetails.status,
        approver: leaveDetails.approver?.name || "N/A",
        document: leaveDetails.document,
      });
    }
  }, [leaveDetails]);

  if (loading || !initialValues) {
    return <Loading />;
  }

  return (
    <SimpleCard>
      <Breadcrumb routeSegments={[{ name: "View Leave Request" }]} />
      <Box padding={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Employee Name"
              value={initialValues.employeeName}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Leave Type"
              value={initialValues.leaveType}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Start Date"
              value={initialValues.startDate}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="End Date"
              value={initialValues.endDate}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Reason"
              multiline
              rows={4}
              value={initialValues.reason}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Status"
              value={initialValues.status}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Processed By"
              value={initialValues.approver}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          {initialValues.document && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>Attachment</Typography>
              <Button
                variant="outlined"
                startIcon={<AttachFileIcon />}
                href={LIVE_URL + initialValues.document}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Attachment
              </Button>
            </Grid>
          )}
          <Grid item xs={12}>
            <Button variant="contained" onClick={() => navigate(-1)}>
              Back
            </Button>
          </Grid>
        </Grid>
      </Box>
    </SimpleCard>
  );
};

export default ViewRequest;